"use client";

import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

export default function HeaderStrip() {
  const { t, currentLang } = useLanguage();
  return (
    <div className="bg-[#047857] h-20 flex items-center">
      <div className="max-w-7xl mx-auto px-4 md:px-6 w-full flex items-center justify-between">
        <div className="flex items-center gap-2 text-white text-sm">
          <Link to="/" className="hover:underline opacity-90">
            {t("nav.home")}
          </Link>
          <span className="opacity-60">&gt;</span>
          <span className="font-semibold">{t("legal.h1")}</span>
        </div>
        <div className="text-white text-sm font-medium">
          {t("legal.lastUpdated")}
        </div>
      </div>
    </div>
  );
}